import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { Transaction, TransactionDispute } from "model";
import DisputeItemServicePage from "components/pages/DisputeTransactionPages/DisputeItemServicePage";
import { getDefaultData } from "components/pages/DisputeTransactionPage/components/DisputeItemServiceView";


export default function CaptureDisputeProductEntered(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Transaction, TransactionDispute ], controller);
        const { branding } = useModel();
    const options = branding.options ?? {};
    
    let transactionID = "98"; // A credit card transaction id.
    if(options.include_credit_chw23 === "false") {
        transactionID = "5"; // A debit card transaction id.
    }
    const data = BCMSStateManagerCRUD.init(getDefaultData(transactionID))
    .update(["dispute", "whatDidYouPurchase"], "Nike Air Force 1 `07 White / Action Green Women's Shoes")
    .submit();

    return (
        <DisputeItemServicePage data={ data }/>
    );
}